import type { Resolver } from 'cpool-schemas';
import { z } from 'zod';

import { TeamsTableDefinitionZod } from '../tables';

type Arguments = {
    divisionAggregateId: string;
    includeDeactivated?: boolean;
    position?: number;
};

export const schemaTeamResolver_ListByDivision = z.array(TeamsTableDefinitionZod);

export type SchemaTeamResolver_ListByDivision = z.infer<typeof schemaTeamResolver_ListByDivision>;

export type TeamResolver_ListByDivision = Resolver<Arguments, SchemaTeamResolver_ListByDivision>;
